import deleteRecord from '@/utils/delete-record'
import updateRecord from '@/utils/update-record'
import { i18n } from '@/plugins/i18n'

const defaultOptions = {
  title: 'Information',
  label: null,
  toaster: 'default',
  component: 'app-toast',
  timeout: 20000
}

const defaultOptionsError = {
  isError: true,
  body: i18n.t('toast-errors.default.no-error-description'),
  flowName: 'default'
}

function tinyId () {
  return (Math.floor(Math.random() * 1e6)).toString(16)
}

const getDefaultState = () => {
  return {
    messages: []
  }
}

const state = getDefaultState()

const actions = {
  addError (context, _payload) {
    const payload = Object.assign({}, defaultOptionsError, _payload)

    // Add error code if necessary
    if (payload.response) {
      const errorCode = _searchError(payload.response)

      if (errorCode) {
        if (i18n.te(`toast-errors.${payload.flowName}.${errorCode}`)) {
          payload.body = i18n.t(`toast-errors.${payload.flowName}.${errorCode}`)
        } else {
          payload.errorCode = errorCode
        }
      }
    }

    actions.addMessage(context, payload)
  },
  addMessage (context, _payload) {
    const payload = Object.assign({}, defaultOptions, _payload)

    if (!payload.timestamp) {
      payload.timestamp = new Date()
    }

    // Add error code if necessary
    if (_payload.response) {
      const errorCode = _searchError(_payload.response)
      if (errorCode) payload.errorCode = errorCode
    }
    context.commit('addMessage', payload)
  },

  removeMessage (context, { id }) {
    context.commit('removeMessage', { id })
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  addMessage ({ messages }, payload) {
    const { label } = payload
    if (label) {
      const message = messages.find(message => message.label === label)
      if (message) {
        payload.id = message.id
        return updateRecord(messages, payload)
      }
    }

    payload.id = tinyId()
    messages.push(payload)
  },

  removeMessage ({ messages }, { id }) {
    deleteRecord(messages, id)
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const _searchError = (data) => {
  if (data.error || data.errors || data.message) return data.error || data.errors || data.message

  const isArray = Array.isArray(data)
  if (isArray || typeof data === 'object') {
    const lines = isArray ? data : Object.values(data)

    for (const line of lines) {
      const result = _searchError(line)
      if (result) {
        return result
      }
    }
  }
  return false
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
